<app-flow-action-card
  icon="record_voice_over"
  iconColor="text-orange-600"
  label="Ga naar interactie"
>
  <div flowCardActions>
    <button
      mat-icon-button
      [disabled]="!targetNodeId()"
      (click)="panToNode.emit(targetNodeId()!)"
      matTooltip="Spring naar interactie"
      class="inline-flex! size-6! p-1!"
    >
      <mat-icon class="size-4! text-base/4! font-medium!">my_location</mat-icon>
    </button>
  </div>

  <span
    class="truncate max-w-40 inline-block align-middle"
    [matTooltip]="label()"
    matTooltipPosition="after"
    >{{ label() }}</span
  >
  @if (version() !== null) {
    <span
      class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium align-middle ml-1"
    >
      v{{ version() }}
    </span>
  }
</app-flow-action-card>
